// contexts/AuthContext.tsx
import React, { createContext, useState, useContext, ReactNode } from 'react';
import { AUTH_TOKEN } from '../../constants';

interface AuthContextProps {
  isAuthorized: boolean;
  setIsAuthorized: (value: boolean) => void;
  loginType: boolean | null;
  setLoginType: (value: boolean | null) => void;
}

const AuthContext = createContext<AuthContextProps | undefined>(undefined);

export const AuthProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isAuthorized, setIsAuthorized] = useState<boolean>(
    !!localStorage.getItem(AUTH_TOKEN)
  );
  const [loginType, setLoginType] = useState<boolean | null>(() => {
    const item = localStorage.getItem('CIRCLEONE_LOGIN_TYPE');
    if (item) {
      try {
        return JSON.parse(item);
      } catch {
        return null;
      }
    }
    return null;
  });

  return (
    <AuthContext.Provider
      value={{ isAuthorized, setIsAuthorized, loginType, setLoginType }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = (): AuthContextProps => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
